import * as Yup from 'yup'

import { STAKEHOLDERS_LIST } from '../../stakeholdersFields'
import { wellbeingRatingsValidation } from '../../validation'
import { COUNTRY_ID, TITLE, TOTAL_ACTIVITY_HOURS, TOTAL_INVESTMENT } from '../../fields'

export const validationSchema = Yup.object({
  [TITLE]: Yup.string().required('Report name is required'),
  [COUNTRY_ID]: Yup.string().required('Country of operation is required'),
  [TOTAL_INVESTMENT]: Yup.string().required('Investment is required'),
  [TOTAL_ACTIVITY_HOURS]: Yup.string().required('Activity hours is required'),
  [STAKEHOLDERS_LIST]: Yup.array().of(
    Yup.object().shape({
      ...wellbeingRatingsValidation
    })
  )
})
